import api from './api';

export const getCompanyNames = async () => {
  const response = await api.get('/api/private/ticket/company-names');
  return response.data;
};
